import { ComponentProps } from "react";
import Loading from "../components/Loading";
import { cn } from "@/utils/tailwind";

export default function Loader({
  children,
  className,
  ...props
}: ComponentProps<"div">) {
  return (
    <div
      {...props}
      className={cn(
        "w-full h-full flex flex-col gap-4 items-center justify-center",
        className,
      )}
      style={
        {
          "--from-opacity": 0,
          "--to-opacity": 1,
          animation: "fade 0.2s ease-in",
        } as React.CSSProperties
      }
    >
      <div className="w-12">
        <Loading />
      </div>
      {children}
    </div>
  );
}
